import { render, staticRenderFns } from "./districtsAddView.vue?vue&type=template&id=c65f51d4&scoped=true"
import script from "./districtsAddView.vue?vue&type=script&lang=js"
export * from "./districtsAddView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65f51d4",
  null
  
)

export default component.exports